module.exports = __webpack_public_path__ + "static/media/how-to-win-interview.89e4db97.png";